import { useState, useRef, useEffect } from 'react';
import { matchTokens } from '../utils/search';

export default function VendorDropdown({vendors,value,onSelect,onClose,placeholder,excludeNames,showAddNew=false,minChars=0,maxResults,t,si,showAllOnEmpty=false}){
const[search,setSearch]=useState('');
const[open,setOpen]=useState(false);
const[hl,setHl]=useState(-1);
const ref=useRef(null);

useEffect(()=>{
  function onKey(e){if(e.key==='Escape'){setOpen(false);if(onClose)onClose();}}
  function onClick(e){if(ref.current&&!ref.current.contains(e.target)){setOpen(false);if(onClose)onClose();}}
  document.addEventListener('keydown',onKey);
  document.addEventListener('mousedown',onClick);
  return()=>{document.removeEventListener('keydown',onKey);document.removeEventListener('mousedown',onClick);};
},[onClose]);

const excludeSet=new Set((excludeNames||[]).map(n=>n.toLowerCase()));

// Normalize: handle both string arrays and object arrays
const names=(vendors||[]).map(v=>typeof v==='string'?v:v.name).filter(Boolean);

const query=open?search:(value||'');
const hasQuery=query.trim().length>=Math.max(minChars,1);
const showList=open&&(hasQuery||showAllOnEmpty);

const filtered=showList?names.filter(n=>
  !excludeSet.has(n.toLowerCase())&&
  matchTokens(n,query)
).sort((a,b)=>a.toLowerCase().localeCompare(b.toLowerCase())).slice(0,maxResults||9999):[];

const exactMatch=filtered.some(n=>n.toLowerCase()===query.trim().toLowerCase());
const showAdd=showAddNew&&showList&&query.trim()&&!exactMatch;
const items=showAdd?['__add_new__',...filtered]:filtered;

function handleKeyDown(e){
  if(!open||!showList)return;
  if(e.key==='ArrowDown'){e.preventDefault();setHl(p=>Math.min(p+1,items.length-1));}
  else if(e.key==='ArrowUp'){e.preventDefault();setHl(p=>Math.max(p-1,0));}
  else if(e.key==='Enter'){
    e.preventDefault();
    if(hl>=0&&hl<items.length){
      const sel=items[hl];
      if(sel==='__add_new__')select(query.trim());
      else select(sel);
    }else if(filtered.length===1){select(filtered[0]);}
    else if(showAdd&&filtered.length===0){select(query.trim());}
  }
}

function select(nameOrObj){
  // Return the original vendor object if vendors are objects, otherwise the string
  const orig=(vendors||[]).find(v=>(typeof v==='string'?v:v.name)===nameOrObj);
  onSelect(orig||nameOrObj);
  setSearch('');
  setOpen(false);
  setHl(-1);
}

return(
<div ref={ref} style={{position:'relative'}}>
<input
  value={open?search:(value||'')}
  onChange={e=>{setSearch(e.target.value);setOpen(true);setHl(-1);}}
  onFocus={()=>{setOpen(true);setSearch(value||'');setHl(-1);}}
  placeholder={placeholder||'Search vendor...'}
  name="vendor-lookup" autoComplete="chrome-off" data-1p-ignore data-lpignore="true"
  onKeyDown={handleKeyDown}
  onBlur={()=>setTimeout(()=>{if(!ref.current?.contains(document.activeElement)){setOpen(false);if(onClose)onClose();}},200)}
  style={{...si,width:'100%',fontSize:11,boxSizing:'border-box'}}
/>
{showList&&<div style={{position:'absolute',top:'100%',left:0,right:0,background:t.sf,border:`1px solid ${t.bd}`,borderRadius:8,maxHeight:'50vh',overflow:'auto',zIndex:20,marginTop:2,boxShadow:'0 4px 12px rgba(0,0,0,0.15)'}}>
{showAdd&&<div onClick={()=>select(query.trim())} style={{padding:'8px 12px',cursor:'pointer',borderBottom:`1px solid ${t.bd}`,fontSize:11,color:t.bl,fontWeight:600,background:hl===0?t.sfh:'transparent'}} onMouseEnter={()=>setHl(0)}>
{query.trim()?`+ Add "${query.trim()}" as new vendor`:'+ Add new vendor...'}
</div>}
{filtered.map((v,i)=>{const idx=showAdd?i+1:i;return(
<div key={v} onClick={()=>select(v)} style={{padding:'8px 12px',cursor:'pointer',borderBottom:`1px solid ${t.bd}`,fontSize:12,background:hl===idx?t.sfh:'transparent'}} onMouseEnter={()=>setHl(idx)}>{v}</div>
);})}
{filtered.length===0&&!showAdd&&<div style={{padding:'8px 12px',fontSize:11,color:t.td,fontStyle:'italic'}}>No matches</div>}
</div>}
{open&&!showList&&query.length>0&&query.length<minChars&&<div style={{position:'absolute',top:'100%',left:0,right:0,background:t.sf,border:`1px solid ${t.bd}`,borderRadius:8,padding:'8px 12px',fontSize:10,color:t.td,zIndex:20,marginTop:2}}>Type {minChars-query.length} more character{minChars-query.length!==1?'s':''} to search</div>}
</div>);
}
